exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram3b2-4 .submit{margin-right:3%;margin-top:50px}.diagram3b2-4__separator{position:absolute;top:106px;left:34px}.diagram3b2-4 .long-arr{width:182px;left:-101px;transform:rotate(26deg);top:-92px}.diagram3b2-4 .long-arr__long-arr-part1{transform:none;width:195px}.diagram3b2-4 .long-arr__long-arr-part2{transform:none;top:39px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/3/3b2/diagram4/diagram4.scss
// module id = 1217
// module chunks = 0